<template>
  <VWidget :title="$t('Applied Discounts')">
    <div slot="widget-content">
      <v-layout
        wrap
        row
        class="mb-2"
      >
        <v-flex
          v-if="coupons.length"
          xs12
          class="mx-0 py-0"
        >
          <v-flex class="subheading my-0">
            {{ $t('Applied Coupons') }}
          </v-flex>
          <order-applied-discount-line
            v-for="(coupon, index) in coupons"
            :key="`coupon-${index}`"
            :coupon="coupon"
            class="mx-3"
          />
        </v-flex>
        <v-flex
          xs12
          class="mx-0"
        >
          <v-flex class="subheading">
            {{ $t('Discounts') }}
          </v-flex>
          <order-applied-discount-line
            v-for="(coupon, index) in nonCoupons"
            :key="`coupon-${index}`"
            :coupon="coupon"
            :show-type="true"
            class="mx-3"
          />
        </v-flex>
      </v-layout>
    </div>
  </VWidget>
</template>

<script>
import OrderAppliedDiscountLine from './OrderSingleDiscount/OrderAppliedDiscountLine'

export default {
  name: 'OrderSingleAppliedDiscounts',
  components: { OrderAppliedDiscountLine },
  props: {
    order: {
      type: Object,
      required: true
    }
  },

  computed: {
    distinctDiscounts () {
      return [...this.order.items, this.order.shipping].reduce(function (accumulator, item) {
        const distinctItems = item.discounts.filter(item => !accumulator.some(x => x.name === item.name))
        accumulator.push(...distinctItems)
        return accumulator
      }, [])
    },

    coupons () {
      return this.distinctDiscounts.filter(item => item.discount_type === 'coupon')
    },

    nonCoupons () {
      return this.distinctDiscounts.filter(item => item.discount_type !== 'coupon')
    }
  }
}
</script>
